module.exports = __webpack_public_path__ + "img/down2-en.4b585927.png";